import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { AiOutlineUser } from 'react-icons/ai';
import { getInlineLoader, setCookie } from "../Helpers";
import {
  STR_AGENCY_REPORTS,
  STR_AGENT_REQUESTS_HISTORY,
  STR_CHANGE_PHONE_NUMBER,
  STR_CONSULTATION_FEE_PAYMENTS,
  STR_CONTACT_US,
  STR_LINK_SUPERVISOR,
  STR_LOGOUT,
  STR_MY_COACH,
  STR_MY_CREATED_AGENT_REQUESTS,
  STR_MY_PARTICIPATED_AGENT_REQUESTS,
  STR_MY_PROCESSED_AGENT_REQUESTS,
  STR_MY_STUDENTS,
  STR_MY_SUBSCRIPTION,
  STR_OTHER_SETTINGS,
  STR_PAYMENT_SETTINGS,
  STR_PERSONAL_SETTINGS,
  STR_SET_CURRENCY,
  STR_SUBSCRIPTION_FEE_PAYMENTS,
  STR_UPDATE_PERSONAL_INFO,
  STR_UPDATE_USERNAME,
  STR_USER_REPORT,
  STR_VERIFY_YOUR_PROFILE,
  STR_WHATSAPP_SETUP,
  STR_YOUR_PROFILE,
  STR_YOUR_REPORTS
} from "../Strings";
import { BsFillPersonLinesFill, BsPersonGear } from 'react-icons/bs';
import { MdAnalytics, MdContactPage, MdCreditCard, MdDetails, MdInfoOutline, MdLink, MdLogout, MdOutlinePayment, MdOutlinePayments, MdOutlinePhonelinkSetup, MdOutlineSupport, MdPerson, MdSupervisorAccount, MdSupportAgent, MdTranslate, MdVerified, MdWhatsapp } from 'react-icons/md';
import { CgProfile } from "react-icons/cg";
import { GrCurrency } from "react-icons/gr";
import { GiTeacher } from "react-icons/gi";
import { FaRegUser } from "react-icons/fa";
import { RiListCheck2, RiListCheck3, RiListOrdered, RiProfileLine } from "react-icons/ri";

export default function View(props) {

  const appContext = useContext(AppContext);

  /* Place states here */
  const [ready, setReady] = useState(false);

  async function init() {
    //run initializations here
    setReady(false);
    await Promise.all([
      appContext.getCurrentUserData(),
      appContext.getSupervisedAccounts(),
    ])
    setReady(true);
  }

  function logOut() {
    appContext.setShowOverlayLoader(true);
    setCookie('userId', "", -10000000);
    setCookie('userToken', "", -10000000);
    appContext.navTo({
      item: '',
    })
    appContext.refresh();
    appContext.setShowOverlayLoader(false);
  }

  useEffect(() => {
    init();
  }, [])



  if (ready) {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          overflow: "scroll",
          paddingTop: "20px",
          paddingBottom: "calc(var(--topBarHeight) + 40px)",
        }}
        className="mNoScrollBar"
      >
        <div className="container">

          <div className="row">

            <div className="col-md-12 text-center">
              <div className="card">
                <div className="card-body">
                  <h1
                    className="text-secondary"
                  >
                    <FaRegUser size={100} />

                    <span
                      style={{
                        display: "block",
                        fontSize: "22px"
                      }}
                      className="font-semi-bold"
                    >
                      +{appContext.currentUserData.phone}
                    </span>

                    <span
                      style={{
                        display: "block",
                        fontSize: "14px"
                      }}
                      className="font-semi-bold"
                    >
                      {appContext.currentUserData.agentName}
                      {(appContext.currentUserData.agentVerificationStatus === 'verified') ? <MdVerified className="text-primary" size={16}/> :""}
                    </span>
                  </h1>
                </div>
              </div>
            </div>

          
            <div className="col-md-6">
              <div className="card">
                <div className="card-body">
                  <h6 className="card-title">
                    {STR_AGENT_REQUESTS_HISTORY[appContext.language]}
                  </h6>


                  <div
                    className="d-flex mb-4 mt-4"
                    style={{
                      padding: "0",

                    }}
                    onClick={() => {
                      
                      appContext.navTo({
                        item: 'account',
                        subItem: 'my-created-agent-requests',
                      })
                    }}
                  >
                    <RiListOrdered className="align-self-center mNoMargin" size={24} style={{ flexShrink: "0" }} />
                    <h6
                      className="mNoMargin align-self-center font-semi-bold"
                      style={{
                        fontSize: "14px",
                        paddingLeft: "20px",
                      }}
                    >
                      {STR_MY_CREATED_AGENT_REQUESTS[appContext.language]}
                    </h6>
                  </div>

                  <div
                    className="d-flex mb-4 mt-4"
                    style={{
                      padding: "0",

                    }}
                    onClick={() => {
                      
                      appContext.navTo({
                        item: 'account',
                        subItem: 'my-processed-agent-requests',
                      })
                    }}
                  >
                    <RiListCheck3 className="align-self-center mNoMargin" size={24} style={{ flexShrink: "0" }} />
                    <h6
                      className="mNoMargin align-self-center font-semi-bold"
                      style={{
                        fontSize: "14px",
                        paddingLeft: "20px",
                      }}
                    >
                      {STR_MY_PROCESSED_AGENT_REQUESTS[appContext.language]}
                    </h6>
                  </div>   

                  <div
                    className="d-flex mb-4 mt-4"
                    style={{
                      padding: "0",

                    }}
                    onClick={() => {
                      
                      appContext.navTo({
                        item: 'account',
                        subItem: 'my-participated-agent-requests',
                      })
                    }}
                  >
                    <RiListCheck2 className="align-self-center mNoMargin" size={24} style={{ flexShrink: "0" }} />
                    <h6
                      className="mNoMargin align-self-center font-semi-bold"
                      style={{
                        fontSize: "14px",
                        paddingLeft: "20px",
                      }}
                    >
                      {STR_MY_PARTICIPATED_AGENT_REQUESTS[appContext.language]}
                    </h6>
                  </div>             

                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="card">
                <div className="card-body">
                  <h6 className="card-title">
                    {STR_AGENCY_REPORTS[appContext.language]}
                  </h6>


                  <div
                    className="d-flex mb-4 mt-4"
                    style={{
                      padding: "0",

                    }}
                    onClick={() => {
                      
                      appContext.navTo({
                        item: 'account',
                        subItem: 'my-agent-reports',
                      })
                    }}
                  >
                    <MdAnalytics className="align-self-center mNoMargin" size={24} style={{ flexShrink: "0" }} />
                    <h6
                      className="mNoMargin align-self-center font-semi-bold"
                      style={{
                        fontSize: "14px",
                        paddingLeft: "20px",
                      }}
                    >
                      {STR_YOUR_REPORTS[appContext.language]}
                    </h6>
                  </div>
                  
                  {
                    (appContext.supervisedAccounts && appContext.supervisedAccounts.length > 0) ?
                    appContext.supervisedAccounts.map((item, i) => {
                      return (
                        <div
                          className="d-flex mb-4 mt-4"
                          style={{
                            padding: "0",

                          }}
                          key={i}
                          onClick={() => {
                            
                            appContext.navTo({
                              item: 'view',
                              subItem: 'supervised-account',
                              extraItem: item.id,
                            })
                          }}
                        >
                          <MdSupervisorAccount className="align-self-center mNoMargin" size={24} style={{ flexShrink: "0" }} />
                          <h6
                            className="mNoMargin align-self-center font-semi-bold"
                            style={{
                              fontSize: "14px",
                              paddingLeft: "20px",
                            }}
                          >
                            {item.agentName}
                          </h6>
                        </div>
                      )
                    })
                    :""
                  }

                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="card">
                <div className="card-body">
                  <h6 className="card-title">
                    {STR_OTHER_SETTINGS[appContext.language]}
                  </h6>

                  {
                    /*
                    (appContext.currentUserData.agentVerificationStatus !== 'verified') ?
                    <div
                      className="d-flex mb-4 mt-4"
                      style={{
                        padding: "0",

                      }}
                      onClick={() => {
                        
                        appContext.navTo({
                          item: 'view',
                          subItem: 'profile-verification',
                        })
                      }}
                    >
                      <MdVerified className="align-self-center mNoMargin" size={24} style={{ flexShrink: "0" }} />
                      <h6
                        className="mNoMargin align-self-center font-semi-bold"
                        style={{
                          fontSize: "14px",
                          paddingLeft: "20px",
                        }}
                      >
                        {STR_VERIFY_YOUR_PROFILE[appContext.language]}
                      </h6>
                    </div>
                    :""
                    */
                  }

                  <div
                    className="d-flex mb-4 mt-4"
                    style={{
                      padding: "0",

                    }}
                    onClick={() => {
                      
                      appContext.navTo({
                        item: 'view',
                        subItem: 'my-subscription',
                      })
                    }}
                  >
                    <MdCreditCard className="align-self-center mNoMargin" size={24} style={{ flexShrink: "0" }} />
                    <h6
                      className="mNoMargin align-self-center font-semi-bold"
                      style={{
                        fontSize: "14px",
                        paddingLeft: "20px",
                      }}
                    >
                      {STR_MY_SUBSCRIPTION[appContext.language]}
                    </h6>
                  </div>

                  <div
                    className="d-none mb-4 mt-4"
                    style={{
                      padding: "0",

                    }}
                    onClick={() => {
                      
                      appContext.navTo({
                        item: 'view',
                        subItem: 'edit-agent-profile',
                      })
                    }}
                  >
                    <RiProfileLine className="align-self-center mNoMargin" size={24} style={{ flexShrink: "0" }} />
                    <h6
                      className="mNoMargin align-self-center font-semi-bold"
                      style={{
                        fontSize: "14px",
                        paddingLeft: "20px",
                      }}
                    >
                      {STR_YOUR_PROFILE[appContext.language]}
                    </h6>
                  </div>

                  
                  <div
                    className="d-flex mb-4 mt-4"
                    style={{
                      padding: "0",

                    }}
                    onClick={() => {
                      appContext.navTo({
                        item: 'view',
                        subItem: 'link-supervisor',
                      })
                    }}
                  >
                    <MdLink className="align-self-center mNoMargin" size={24} style={{ flexShrink: "0" }} />
                    <h6
                      className="mNoMargin align-self-center font-semi-bold"
                      style={{
                        fontSize: "14px",
                        paddingLeft: "20px",
                      }}
                    >
                      {STR_LINK_SUPERVISOR[appContext.language]}
                    </h6>
                  </div>
                  
                  <div
                    className="d-flex mb-4 mt-4"
                    style={{
                      padding: "0",

                    }}
                    onClick={() => {
                      appContext.navTo({
                        item: 'view',
                        subItem: 'contact_us',
                      })
                    }}
                  >
                    <MdSupportAgent className="align-self-center mNoMargin" size={24} style={{ flexShrink: "0" }} />
                    <h6
                      className="mNoMargin align-self-center font-semi-bold"
                      style={{
                        fontSize: "14px",
                        paddingLeft: "20px",
                      }}
                    >
                      {STR_CONTACT_US[appContext.language]}
                    </h6>
                  </div>

                  <div
                    className="d-flex mb-4 mt-4"
                    style={{
                      padding: "0",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      if (appContext.language === 'en') {
                        appContext.setLanguage("sw");
                      } else {
                        appContext.setLanguage("en");
                      }
                    }}
                  >
                    <MdTranslate className="align-self-center mNoMargin" size={24} style={{ flexShrink: "0" }} />
                    <h6
                      className="mNoMargin align-self-center font-semi-bold"
                      style={{
                        fontSize: "14px",
                        paddingLeft: "20px",
                      }}
                    >
                      {(appContext.language === 'en') ? "Tumia Kiswahili" : "Use English"}
                    </h6>
                  </div>

                  

                  <div
                    className="d-flex mb-4 mt-4"
                    style={{
                      padding: "0",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      appContext.activateDialog({
                        message: STR_LOGOUT[appContext.language] + "?",
                        onConfirm: logOut,
                      })
                    }}
                  >
                    <MdLogout className="align-self-center mNoMargin" size={24} />
                    <h6
                      className="mNoMargin align-self-center font-semi-bold"
                      style={{
                        fontSize: "14px",
                        paddingLeft: "20px",
                      }}
                    >
                      {STR_LOGOUT[appContext.language]}
                    </h6>
                  </div>

                </div>
              </div>
            </div>

          </div>

        </div>


      </div>
    )
  } else {
    return (
      <div
        className="mSupportLoading"
        style={{
          width: "100%",
          height: "100%",
        }}
      >
        {getInlineLoader()}
      </div>
    );
  }


}